import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Alert, Button, Card, Col, Row, Form, FloatingLabel } from 'react-bootstrap';
import DUNLOP_LOGO from '../../assets/img/login_logo.png';
import '../../assets/css/login/login.css';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { roles } from '../../utils/define';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

type LoginApiRequestParam = {
    email: string;
    password: string;
    isRegist: boolean;
};

const initialLoginDataState: LoginApiRequestParam = { email: "", password: "", isRegist: false };

const Login = () => {
    const { saveAuthData } = useAuth();
    const navigate = useNavigate();
    const [loginData, setLoginData] = useState<LoginApiRequestParam>(initialLoginDataState);
    const [errorMessage, setErrorMessage] = useState('');
    const [opacity, setOpacity] = useState(1);
    useEffect(() => {
        if (errorMessage != '') {
          const timer = setTimeout(() => {
            setOpacity(0);
            setTimeout(() => setErrorMessage(''), 1000);
          }, 5000);
          return () => clearTimeout(timer);
        }
    }, [errorMessage]);
    const callLoginApi = (param: LoginApiRequestParam) => {
        console.log(`click login button. email = ${param.email}, password = ${param.password}, isRegist = ${param.isRegist}`);
    
        axios.post(`${API_BASE_URL}/login`, {}, {
            headers: {
                email: param.email,
                password: param.password,
                isRegist: param.isRegist,
            }
        })
        .then(response => {
            console.log('Login response:', response.data);
            if (response.status === 200) {
                console.log('success', response.data);
                const authData = response.data;
                saveAuthData(authData, param.isRegist); // 認証情報をクッキーに保存する
                if(authData.roles.includes(roles.sys_admin)) {
                    navigate('/partners');  // 認証成功後にレポートダウンロード画面へ遷移
                } else {
                    let url = "/partner/" + authData.partner_id;
                    if(authData.client_id) {
                        url += "/client/" + authData.client_id
                    }
                    navigate(url, {state : {
                        adminId: authData.admin_id,
                        sysStatus: authData.sys_status
                    }});
                }
            } else {
                console.error('Login failed:', response.data.message || 'Unknown error');
            }
        })
        .catch(error => {
            if (error.response.status === 401) {
                setErrorMessage('メールアドレス もしくはパスワードが不正です。');
            } else {
                setErrorMessage('エラーが発生しました。もう一度お試しください。');
            }
            setOpacity(1);
        });
    };

    return (
        <div className='login_wrapper'>
            <Card className='login_card'>
                <Card.Img src={DUNLOP_LOGO} />                
                {errorMessage && <Alert variant="danger" style={{margin: "12px", padding: "10px 12px", fontSize: "14px", opacity: opacity, transition: 'opacity 1s ease'}}>{errorMessage}
                <Button variant="close" onClick={() => setErrorMessage('')} aria-label="Close" style={{height:"15px", width:"15px", float: "right"}}></Button>
                    </Alert>}
                <Card.Body>
                    <Row className='card_row'>
                        <Card.Title style={{textAlign:"center"}}>月次タイヤレポートダウンロード</Card.Title>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="メールアドレス"
                        >
                        <Form.Control 
                            type="email" 
                            defaultValue={loginData.email}
                            onChange={(event) => setLoginData({email: event.target.value, password: loginData.password, isRegist: loginData.isRegist})}
                        />
                        </FloatingLabel>
                    </Row>
                    <Row className='card_row'>
                        <FloatingLabel controlId="floatingPassword" label="パスワード">
                            <Form.Control 
                                type="password" 
                                defaultValue={loginData.password}
                                onChange={(event) => setLoginData({email: loginData.email, password: event.target.value, isRegist: loginData.isRegist})}
                            />
                        </FloatingLabel>
                    </Row>
                    <Row className='card_row'>
                        <Col>
                            <Form.Check
                                label="ログイン状態を保持する"
                                name="group1"
                                type="radio"
                                id="inline-radio-1"
                                value="1"
                                onChange={(event)=>setLoginData({email: loginData.email, password: loginData.password, isRegist: event.target.value==="1"})}
                            />
                        </Col>
                        <Col>
                            <Form.Check
                                label="ログイン状態を削除する"
                                name="group1"
                                type="radio"
                                id="inline-radio-2"
                                value="2"
                                onChange={(event)=>setLoginData({email: loginData.email, password: loginData.password, isRegist: event.target.value==="1"})}
                            />
                        </Col>
                    </Row>
                    <Row className='card_row'>
                        <div style={{textAlign:"center"}}>
                            パスワードを忘れた方は<a href={process.env.REACT_APP_DC_URL_ADMIN_PASSWORD_NEW}>こちら</a>へ
                        </div>
                    </Row>
                </Card.Body>
                <Card.Footer style={{textAlign: "center"}}>
                    <Button onClick={() => callLoginApi(loginData)} variant="primary" style={{width:"90%"}}>ログイン</Button>
                </Card.Footer>
            </Card>
        </div>
    );
};

export default Login;